import React, { useState } from "react";

const hotelIcon = () => {
    return (
        <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M3 4V20C3 20.9428 3 21.4142 3.29289 21.7071C3.58579 22 4.05719 22 5 22H19C19.9428 22 20.4142 22 20.7071 21.7071C21 21.4142 21 20.9428 21 20V4M10.5 8V9.5M10.5 9.5V11M10.5 9.5H13.5M13.5 8V9.5M13.5 9.5V11M14 22V17.9999C14 16.8954 13.1046 15.9999 12 15.9999C10.8954 15.9999 10 16.8954 10 17.9999V22M2 4H8C8.6399 2.82727 10.1897 2 12 2C13.8103 2 15.3601 2.82727 16 4H22M6 8H7M6 12H7M6 16H7"
                stroke="#8DA0A2"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M17 8H18M17 12H18M17 16H18"
                stroke="#8DA0A2"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

const flyingIcon = () => {
    return (
        <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M2.00031 20H18.0003M3.82527 12.1661C3.55027 11.9661 3.30027 11.7161 3.00028 10.8411C2.91891 10.6241 2.61139 9.53619 2.35028 8.54109C2.13003 7.7017 1.93377 6.93555 2.02528 6.74109C2.10029 6.54109 2.20027 6.39109 2.52527 6.19109C2.72527 6.06802 3.75027 5.81609 3.95027 5.76609C4.15027 5.71609 4.42526 5.69109 4.65027 5.76609C5.07527 5.84109 5.95027 7.11609 6.17527 7.26609C6.27526 7.36609 6.60027 7.657 6.97527 7.69109C7.25027 7.71609 7.52527 7.64109 7.82528 7.51609C8.10027 7.40151 13.5253 4.76609 14.0253 4.54109C18.1003 2.84109 21.0603 5.63609 21.5103 6.23609C21.9753 6.81609 22.0753 6.99109 21.9503 7.49109C21.7887 8.01609 21.3503 8.11609 21.1003 8.19109C20.8503 8.26609 17.4003 9.19109 16.0503 9.56609C15.7554 9.6621 15.6114 9.85492 15.5753 9.89109C15.4003 10.1411 14.6053 11.8411 14.3803 12.2161C14.2253 12.6161 13.8003 13.1161 13.2503 13.3161C12.6753 13.5161 11.6753 13.7411 11.4503 13.8161C11.2253 13.8911 10.7003 14.0411 10.5253 13.9911C10.3003 13.9411 10.0853 13.7161 10.1853 13.3661C10.2853 13.0161 10.4753 12.0411 10.5003 11.8911C10.5253 11.7411 10.7753 11.1161 10.5003 11.0911C10.4503 11.0161 9.92527 11.2411 9.15027 11.4161C8.57449 11.5782 7.9715 11.7386 7.55027 11.8411C5.92527 12.3161 5.04521 12.4411 4.85027 12.4411C4.47527 12.4411 4.20027 12.3911 3.82527 12.1661Z"
                stroke="#8DA0A2"
                strokeWidth="1.5"
                strokeLinecap="round"
            />
        </svg>
    );
};

const addonsIcon = () => {
    return (
        <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M15 6.5H9M15 6.5C17.8284 6.5 19.2426 6.5 20.1213 7.37868C21 8.25736 21 9.67157 21 12.5V15C21 17.8284 21 19.2426 20.1213 20.1213C19.2426 21 17.8284 21 15 21H9C6.17157 21 4.75736 21 3.87868 20.1213C3 19.2426 3 17.8284 3 15V12.5C3 9.67157 3 8.25736 3.87868 7.37868C4.75736 6.5 6.17157 6.5 9 6.5M15 6.5V6C15 4.58579 15 3.87868 14.5607 3.43934C14.1213 3 13.4142 3 12 3C10.5858 3 9.87868 3 9.43934 3.43934C9 3.87868 9 4.58579 9 6V6.5M7 6.5V21M17 6.5V21"
                stroke="#8DA0A2"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

// Single-person outline — used as the "Lead Passenger" section header.
const PersonIcon = ({ className }) => {
    return (
        <svg
            width="17"
            height="20"
            viewBox="0 0 17 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={className}
        >
            <path
                d="M8.40918 11.5C5.64776 11.5 3.40918 9.2614 3.40918 6.5C3.40918 3.73858 5.64776 1.5 8.40918 1.5C11.1706 1.5 13.4092 3.73858 13.4092 6.5C13.4092 9.2614 11.1706 11.5 8.40918 11.5ZM8.40918 11.5C12.2752 11.5 15.4092 14.634 15.4092 18.5M8.40918 11.5C4.54319 11.5 1.40918 14.634 1.40918 18.5"
                stroke="#8DA0A2"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

// Two-people outline — used as the "All passengers" section header.
const PeopleIcon = ({ className }) => {
    return (
        <svg
            width="21"
            height="20"
            viewBox="0 0 21 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={className}
        >
            <path
                d="M7.40918 13C5.20004 13 3.40918 11.2091 3.40918 9C3.40918 6.79086 5.20004 5 7.40918 5C9.61828 5 11.4092 6.79086 11.4092 9C11.4092 11.2091 9.61828 13 7.40918 13ZM7.40918 13C10.7229 13 13.4092 15.6863 13.4092 19M7.40918 13C4.09547 13 1.40918 15.6863 1.40918 19M9.44778 5.55773C9.42228 5.37547 9.40918 5.18927 9.40918 5C9.40918 2.79086 11.2001 1 13.4092 1C15.6183 1 17.4092 2.79086 17.4092 5C17.4092 7.20914 15.6183 9 13.4092 9M13.4092 9C12.6646 9 11.9676 8.7966 11.3706 8.4423M13.4092 9C16.7229 9 19.4092 11.6863 19.4092 15"
                stroke="#8DA0A2"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

// Bulleted-list glyph — used as the "Booking summary" section header.
const SummaryListIcon = ({ className }) => {
    return (
        <svg
            width="19"
            height="16"
            viewBox="0 0 19 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={className}
        >
            <path
                d="M5.40918 1H17.4092M1.40918 1H1.41816M1.40918 8H1.41816M1.40918 15H1.41816M5.40918 8H17.4092M5.40918 15H17.4092"
                stroke="#8DA0A2"
                strokeWidth="1.5"
                strokeLinecap="round"
            />
        </svg>
    );
};

// Swap/pen glyph — used on the "Edit Details" buttons at checkout.
const EditIcon = ({ className }) => {
    return (
        <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={className}
        >
            <path
                d="M14.375 3.125H6.125C3.34004 3.125 1.25 5.13877 1.25 8M1.625 12.875H9.875C12.66 12.875 14.75 10.8613 14.75 8M12.875 1.25C12.875 1.25 14.75 2.63092 14.75 3.12502C14.75 3.61912 12.875 5 12.875 5M3.12498 11C3.12498 11 1.25001 12.3809 1.25 12.875C1.24999 13.3691 3.125 14.75 3.125 14.75"
                stroke="#5F6C6E"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

// Long right arrow — used on "Proceed" style buttons.
const ArrowRightIcon = ({ className }) => {
    return (
        <svg
            className={className}
            width="18"
            height="12"
            viewBox="0 0 18 12"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M17 5.9998H1M17 5.9998C17 7.3174 12.0002 11 12.0002 11M17 5.9998C17 4.6822 12.0001 1 12.0001 1"
                stroke="#8DA0A2"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

// Warning triangle — used for the "Important information" headings.
const WarningTriangleIcon = ({ className }) => {
    return (
        <svg
            width="22"
            height="20"
            viewBox="0 0 22 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={className}
        >
            <path
                d="M11 15V10.5M11 6.99828V6.98828M12.9248 19H9.0752C4.44476 19 2.12955 19 1.27636 17.4939C0.423174 15.9879 1.60736 13.9914 3.97574 9.9985L5.90057 6.75333C8.17559 2.91778 9.3131 1 11 1C12.6869 1 13.8244 2.91777 16.0994 6.75332L18.0243 9.9985C20.3926 13.9914 21.5768 15.9879 20.7236 17.4939C19.8704 19 17.5552 19 12.9248 19Z"
                stroke="#FF5500"
                strokeWidth="1.8"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

const InfoIcon = ({ size = 20 }) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            x="0px"
            y="0px"
            width={size}
            height={size}
            viewBox="0 0 32 32"
            className="inline"
            fill="#009DD6"
        >
            <path d="M 16 3 C 8.832031 3 3 8.832031 3 16 C 3 23.167969 8.832031 29 16 29 C 23.167969 29 29 23.167969 29 16 C 29 8.832031 23.167969 3 16 3 Z M 16 5 C 22.085938 5 27 9.914063 27 16 C 27 22.085938 22.085938 27 16 27 C 9.914063 27 5 22.085938 5 16 C 5 9.914063 9.914063 5 16 5 Z M 15 10 L 15 12 L 17 12 L 17 10 Z M 15 14 L 15 22 L 17 22 L 17 14 Z"></path>
        </svg>
    );
};
export {
    hotelIcon,
    flyingIcon,
    addonsIcon,
    InfoIcon,
    PersonIcon,
    PeopleIcon,
    SummaryListIcon,
    EditIcon,
    ArrowRightIcon,
    WarningTriangleIcon,
};
